import { useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import { withRouterProps } from '../../../utils'

const NotFound = props => {
  const {
    store: {
      config: { isRetail },
    },
    onboarding: { chosenSpendingOrSaving },
    navigate,
  } = props

  useEffect(() => {
    if (isRetail && chosenSpendingOrSaving === false) {
      navigate('/welcome/saving-or-spending', { replace: true })

      return
    }

    return navigate('/welcome/accept-terms', { replace: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}

export default withRouterProps(inject('store', 'onboarding')(observer(NotFound)))
